import { record } from 'fp-ts';

export interface ObjectDiffResult<TKey extends string = string> {
  added: TKey[];
  modified: TKey[];
  removed: TKey[];
}

export function objectDiff<
  T extends { [Key in TKey]: unknown },
  TKey extends string,
>(oldObject: T, newObject: T): ObjectDiffResult<TKey> {
  const added: TKey[] = [];
  const modified: TKey[] = [];
  const removed: TKey[] = [];
  for (const [key, value] of record.toArray(oldObject)) {
    if (!Object.hasOwnProperty.call(newObject, key)) {
      removed.push(key);
    } else if (newObject[key] !== value) {
      modified.push(key);
    }
  }
  for (const key of record.keys(newObject)) {
    if (!Object.hasOwnProperty.call(oldObject, key)) {
      added.push(key);
    }
  }
  return { added, modified, removed };
}
